import { AlertDialog, renderReactDialog } from "client/Components";
import { ReactElement } from "react";
import { localize } from "client_legacy/ndaw/culture";

export type AppColorDarkThemeInfoDialogProps = {
	onClose(): void;
};

export const AppColorDarkThemeInfoDialog = (props: AppColorDarkThemeInfoDialogProps): ReactElement => (
	<AlertDialog
		title={localize("_AppColor")}
		onClose={props.onClose}
		showCloseButton
		trackingId="app-color-dark-theme-info"
	>
		{localize("_DefaultAppColorForDarkThemeInfo")}
	</AlertDialog>
);
AppColorDarkThemeInfoDialog.displayName = "AppColorDarkThemeInfoDialog";

export function openAppColorDarkThemeInfoDialog(): void {
	renderReactDialog(
		(onClose) => (
			<AppColorDarkThemeInfoDialog
				onClose={onClose}
			/>
		)
	);
};